import { useMemo, useState } from 'react'
import { Link } from 'gatsby'
import { Button, Card, Error, SEO, Title } from 'components/common'
import { useDiscountsQuery, Discount } from 'lib/graphql/storeadmin'
import 'components/discounts/discount-style.css'
import { DiscountTable } from 'components/discounts/DiscountTable'

export const Head = () => <SEO title="ディスカウント" />

const IndexPage = (): JSX.Element => {
  const [tab, setTab] = useState<string>('ALL')
  const { data, loading, error } = useDiscountsQuery({
    fetchPolicy: 'cache-and-network',
  })

  const dataSource = useMemo<Array<Discount>>(() => {
    const discountData = []
    // eslint-disable-next-line array-callback-return
    data?.discounts?.map((d) => {
      discountData.push({
        key: d.id,
        id: d.id,
        title: d.title,
        discountPercent: d.discountPercent.discountPercentLabel,
        usageLimit: d.usageLimit,
        status: d.status,
        product: d.product?.name.jaJp ?? '全体',
        canOverlap: d.canOverlap,
      })
    })
    const source = discountData.reduce(
      (result: Discount[], discount: Discount) => {
        switch (tab) {
          case 'ALL':
            return [...result, discount]
          case 'ACTIVE':
            if (discount.status === 'ACTIVE') return [...result, discount]
            break
          case 'ARCHIVED':
            if (discount.status === 'ARCHIVED') return [...result, discount]
            break
          default:
            break
        }
        return result
      },
      []
    )
    return source
  }, [data, tab])

  if (error) {
    return Error.render(error)
  }

  return (
    <>
      <div className="flex justify-between items-center">
        <Title level={2}>ディスカウント</Title>
        <Button className="" type="primary">
          <Link to={'./new'}>ディスカウントを作成する</Link>
        </Button>
      </div>
      <Card
        tabList={[
          { key: 'ALL', tab: 'すべて' },
          { key: 'ACTIVE', tab: 'アクティブ' },
          { key: 'ARCHIVED', tab: 'アーカイブ済み' },
        ]}
        shadow
        defaultActiveTabKey="ALL"
        onTabChange={(key: string) => setTab(key)}
        className="w-100"
      >
        <DiscountTable dataSource={dataSource} loading={loading} />
      </Card>
    </>
  )
}

export default IndexPage
